import { useState } from "react";
// import createInstance from '../axiosAuth'
import createInstance, { axiosNoSession } from "../config/axiosAuth";
import { useNavigate } from "react-router-dom";

const useNetworkHandler = () => {
  const navigate = useNavigate()
  const [session, setSession] = useState();
  const [networkError, setNetworkError] = useState(false);
  const [alertToast, setAlertToast] = useState(false);
  const [errMsg, setErrMsg] = useState("");
 
  createInstance.interceptors.response.use(
    (res) => {
      const token = localStorage.getItem('session_id');
        if (token) {
            res.headers['Authorization'] = 'Bearer ' + token;
        }
        res.headers['Content-Type'] = 'application/json';
      // res.headers.Authorization = "Bearer " + localStorage.getItem("session_id")
      // if (res.data?.statusCode == 1) {
      //     setNetworkError(true)
      //     return res
      // }  
      if (res.data?.status == 0) { 
     

        navigate('/login')
        setAlertToast(true);
        setErrMsg(res.data?.message);
      }

      
      return res;
    },
    (error) => {
      const expectedError =
        error.response?.status >= 400 && error.response?.status < 500;
      // console.log('expected error =>', expectedError)
      // if (error?.message == 'Network Error') error.response.status = 403
       
      if (expectedError && error.response?.status !== 408) {
        setSession(true)
      } else { 
        setNetworkError(true);
      }
      return Promise.reject(error);
    }
  );

  axiosNoSession.interceptors.response.use(
    (res) => {
     
      if (res.data?.status == 0) { 
        setAlertToast(true);
        setErrMsg(res.data?.message);
      }
      return res;
    },
    (error) => {
      const expectedError =
        error.response?.status >= 400 && error.response?.status < 500;
      // console.log('expected error =>', expectedError)
      // if (error?.message == 'Network Error') error.response.status = 403 
      if (expectedError && error.response?.status !== 408) {
        // setSession(true)
      } else { 
        setNetworkError(true);
      }
      return Promise.reject(error);
    }
  );

  // useEffect(() => {
  //     console.log('session network handler =>',session)
  // }, [session])
  // console.log("DID ERROR OCCURED :", networkError)

  return [
    session,
    setSession,
    networkError,
    setNetworkError,
    alertToast,
    setAlertToast,
    errMsg,
  ];
};

export default useNetworkHandler;
